module.exports = __webpack_public_path__ + "static/img/xiaopeng.582bd24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/xiaopeng.jpg
// module id = mTPA
// module chunks = 0